import { environment } from '../environments/environment';

export const APP_CONFIG = {
  apiBaseUrl: environment.apiBaseUrl,
  appName: environment.appName,
  compact: environment.compact,
  logo: environment.logo,
  logoWhite: environment.logoWhite,
  sortQueryParam: 'sort',
  sortRequestParam: 'sort',
};
